import { useContext } from "@wordpress/element";
import { ToastContext } from "../context/ToastContext";
export function useToast() {
    return useContext(ToastContext);
}
